export const newsletterFrequencies = {
  NONE: 'NONE',
  WEEKLY: 'WEEKLY',
};
